'use server';

import { SessionService } from '@/contexts/authentication';
import { fetchMazeImageQuota, mazePricing } from '../infrastructure/mazeBilling';

export interface MazeImageQuota {
  /** Photo mazes the account can still make; null for anon / accounts unreadable. */
  remaining: number | null;
  /** Current onboarding gift size in mazes (admin-set) — for the "gift used up" copy. */
  giftMazes: number;
}

/**
 * Hidden-tokens view of the games allowance for the signed-in account, plus the
 * current gift size. Display-only: the authoritative check is the server-side
 * reserve in the enqueue path.
 */
export async function getMazeImageQuota(): Promise<MazeImageQuota> {
  const { giftMazes } = await mazePricing();
  const user = await SessionService.getUser();
  const accountId = user?.accountId;
  if (!accountId) return { remaining: null, giftMazes };
  return { remaining: await fetchMazeImageQuota(accountId), giftMazes };
}
